module.exports = __webpack_public_path__ + "assets/images/KYD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/KYD5.png
// module id = 1415
// module chunks = 1